export function formatPowerForGraph(value, magnitude): { value: number } {
  if (isNaN(value) || value === null) {
    return { value: 0 };
  }

  const prefixes = ['', 'k', 'M', 'G', 'T'];

  let negative = false;
  if (magnitude > 0) {
    value = parseFloat(value);

    if (value < 0) {
      value = -value;
      negative = true;
    }

    while (magnitude > 0) {
      value /= 1000;
      magnitude--;
    }
  }

  const result = negative === false ? value : -value;
  return {
    value: Math.round(result * 100) / 100
  };
}

export function findPower(value) {
  value = parseFloat(value);

  if (value === 0) {
    return { value: 0 };
  }

  // Determine the sign of the input value
  const sign = Math.sign(value);

  // Take the absolute value for calculations
  value = Math.abs(value);

  // Calculate the power of 10 that's greater or equal to the absolute value
  const exponent =
    value < 1
      ? -(Math.floor(Math.abs(Math.log10(value))) + 1)
      : Math.floor(Math.log10(value));

  // Compute the nearest power of 10
  const nearestPowerOf10 = Math.pow(10, exponent);

  // Restore the sign to the result
  const result = nearestPowerOf10 * sign;

  return { value: result };
}
